<template>
    <div class="nasabah">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <h4 class="title">
                Daftar Rekening Bank
            </h4>
            <div>
                Urutkan dari
                <select name="" id="" class="select-sort" v-model="sortValue" @change="filterSort">
                    <option :value="{sortBy: 'created_at', sortDir: '-1'}">Terbaru</option>
                    <option :value="{sortBy: 'created_at', sortDir: '1'}" selected>Terlama</option>
                    <option :value="{sortBy: 'fullname', sortDir: '1'}">Nama Peserta A-Z</option>
                    <option :value="{sortBy: 'fullname', sortDir: '-1'}">Nama Peserta Z-A</option>
                </select>
            </div>
        </div>
        <div class="content">
            <table class="table">
                <thead>
                    <th>No</th>
                    <th>Tanggal Pengajuan</th>
                    <th>Nama Peserta</th>
                    <th>
                        <div class="d-flex justify-content-between">
                            Platform
                            <div >
                                <DropdownDirective>
                                    <template v-slot:buttonDropdown><b-icon icon="filter" class="icon-filter"></b-icon></template>
                                    <template v-slot:menuDropdown>
                                        <ul class="container-dropdown">
                                            <li>
                                                <input type="radio" name="" id="" :value="null" v-model="platformValue" @change="filterPlatform">
                                                <label for="">Semua</label>
                                            </li>
                                            <li v-for="(platform, i) in platformDatas" :key="i">
                                                <input type="radio" :value="platform" :name="platform" id="" v-model="platformValue" @change="filterPlatform">
                                                <label for="">{{ platform }}</label>
                                            </li>
                                        </ul>
                                    </template>
                                </DropdownDirective>
                            </div>
                        </div>
                    </th>
                    <th>
                            Bank
                    </th>
                    <th>No. Rekening</th>
                    <th>
                        <div class="d-flex justify-content-between">
                            Status
                            <DropdownDirective>
                                <template v-slot:buttonDropdown><b-icon icon="filter" class="icon-filter"></b-icon></template>
                                <template v-slot:menuDropdown>
                                    <ul class="container-dropdown">
                                        <li>
                                            <input type="radio" :value="null" name="" id="" @change="filterStatus" v-model="statusValue">
                                            <label for="">Semua</label>
                                        </li>
                                        <li>
                                            <input type="radio" value="UNVERIFIED" name="UNVERIFIED" id="" @change="filterStatus" v-model="statusValue">
                                            <label for="">Diproses</label>
                                        </li>
                                        <li>
                                            <input type="radio" value="ACCEPTED" name="ACCEPTED" id="" @change="filterStatus" v-model="statusValue">
                                            <label for="">Terverifikasi</label>
                                        </li>
                                        <li>
                                            <input type="radio" value="REJECTED" name="" id="" @change="filterStatus" v-model="statusValue">
                                            <label for="">Ditolak</label>
                                        </li>
                                    </ul>
                                </template>
                            </DropdownDirective>
                        </div>
                    </th>
                    <th>Aksi</th>
                </thead>
                <tbody v-if="isLoadingManagingBank">
                    <tr>
                        <td colspan="8" class="text-center">
                            <b-spinner></b-spinner>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr v-for="(managingData, i) in managingDatas" :key="i" v-show="managingDatas">
                       <td>{{ (currentPage - 1) * perPage + (i + 1) }}</td>
                       <td>{{ managingData.created_at | formatDateTimewib}}</td>
                       <td>{{managingData.fullname}}</td>
                       <td>{{managingData.app_name}}</td>
                       <td>
                            <img :src="managingData.bank_logo" alt="bank-logo" class="logo-bank">
                            <span>
                                {{managingData.bank_name}}
                            </span>
                        </td>
                       <td>{{managingData.account_no}}</td>
                       <td>
                        <div class="status-bank-account process" v-if="managingData.status == 'UNVERIFIED'">Diproses</div>
                        <div class="status-bank-account success" v-if="managingData.status == 'ACCEPTED'">Terverifikasi</div>
                        <div class="status-bank-account rejected" v-if="managingData.status == 'REJECTED'">Ditolak</div>
                       </td>
                       <td>
                        <router-link :to="'/list-bank-account-detail/' + managingData._id">
                            <button type="button" class="buttons btn-info btn-xs">Detail</button>
                        </router-link>
                       </td> 
                    </tr>
                    <tr v-show="!managingDatas || managingDatas.length == 0" style="border-bottom: solid 1px #DDE1E5;">
                        <td colspan="8" class="text-center"> 
                            Tidak ada data.
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="totalData > perPage && !isLoadingManagingBank" class="d-flex justify-content-between mt-3">
                <div>
                    <span>Menampilkan {{ currentPage * perPage > totalData ? totalData : currentPage * perPage }}</span> dari 
                    <span>{{ totalData }} data</span>
                </div>
                <b-pagination
                    class="justify-content-end"
                    v-model="currentPage"
                    :total-rows="totalData"
                    :per-page="perPage"
                    @change="handlePageChange"
                    aria-controls="new-table"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import DropdownDirective from '../dropdown/DropdownDirective.vue';

export default{
    components:{
        DropdownDirective
    },
    data(){
        return{
            platformDatas: null,
            platformValue: null,
            currentPage: 1,
            perPage: 10,
            sortValue: {
                sortBy: 'created_at',
                sortDir: '1'
            },
            bankValue: '',
            statusValue: null,
            managingDatas: null,
            totalData: null,
            dataAllAccount: [],
            bankLogo: null
        }
    },
    mounted(){
        this.$store.dispatch("getPlatformList").then(res=>{
                this.platformDatas = res.app_name
        })
        if(this.$route.query.status){
            this.statusValue = this.$route.query.status
        }
        if(this.$route.query.platform){
            this.platformValue = this.$route.query.platform
        }
        if(this.$route.query.page){
            this.currentPage = this.$route.query.page
        }
        this.getDataManagingBank(this.statusValue, this.platformValue, this.currentPage, this.perPage, this.sortValue)
        
    },
    methods:{
        getDataManagingBank(status, app_name){
            this.$store.dispatch('getManagingBank', {status: status, app_name: app_name, currentPage:this.currentPage, limit: this.perPage, sortValue: this.sortValue}).then(res=>{
                this.dataAllAccount = res.bank_accounts
                this.managingDatas = res.bank_accounts
                this.totalData = res.page_metadata.count
            })
        },
        setQueryParams(queryParams){
            this.$router.replace({path: '/list-bank-account', query: queryParams})
        },
        handlePageChange(value){
            this.currentPage = value
            this.$router.replace({path: '/list-bank-account', query:{...this.$route.query, page: value}})
            this.getDataManagingBank(this.statusValue, this.platformValue, this.currentPage, this.perPage, this.sortValue)
            
        },
        filterPlatform(){
            this.currentPage = 1
            if(this.platformValue == null){
                this.platformValue = undefined
            }
            this.$router.replace({path: '/list-bank-account', query:{...this.$route.query, platform: this.platformValue}})
            this.getDataManagingBank(this.statusValue, this.platformValue, this.currentPage, this.perPage, this.sortValue)
            
        },
        filterSort(){
            this.currentPage = 1
            this.getDataManagingBank(this.statusValue, this.platformValue, this.currentPage, this.perPage, this.sortValue)
        },
        filterStatus(){
            this.currentPage = 1
            if(this.statusValue == null){
                this.statusValue = undefined
            }
            this.$router.replace({path: '/list-bank-account', query:{...this.$route.query, status: this.statusValue}})
            this.getDataManagingBank(this.statusValue, this.platformValue, this.currentPage, this.perPage, this.sortValue)
        },
    },
    computed:{
        isLoadingManagingBank(){
            return this.$store.state.adminModule.loading_status
        },
        sortedData(){
            return [...this.dataAllAccount].sort((a,b)=>{
                let dateA = new Date(a.created_at)
                let dateB = new Date(b.created_at)
                if(this.sortValue == 'newest'){
                    return dateB - dateA
                } else if(this.sortValue == 'latest'){
                    return dateA - dateB
                } else if(this.sortValue == 'ascending'){
                    return a.account_name.toLowerCase().localeCompare(b.account_name.toLowerCase())
                } else if(this.sortValue == 'descending'){
                    return b.account_name.toLowerCase().localeCompare(a.account_name.toLowerCase())

                }
            })
        },
        limitedData(){
            const start = (this.currentPage - 1) * this.perPage
            const end = start + this.perPage
            return this.sortedData.slice(start, end)
        }
    }
}

</script>

<style scoped>
table {
    color: #707070;
}
.nasabah {
    font-size: 14px;
    background-color: #fff;
    border-radius: 1rem;
    box-shadow: 0 20px 27px 0 rgb(0 0 0 / 5%);
    padding: 1.5rem;
    height: 100%;
}

.title {
    font-size: 22px;
    font-weight: bold;
}

.select-sort{
    border: solid 1px #D0D5DD;
    padding:0.5rem 0.75rem;
    border-radius: 0.5rem;
}

.select-sort:focus{
    outline: none;
}

.status-bank-account{
    padding: 0.25rem 0.5rem;
    border-radius: 1.25rem;
    width: fit-content;
}

.status-bank-account.process{
    background-color: #FFF8F0;
    color: #FD9726;
}

.status-bank-account.success{
    background-color: #F1F9F1;
    color: #327435;
}
.status-bank-account.rejected{
    background-color: #FDF1F1;
    color: #DC362E;
}

.container-dropdown{
    list-style: none;
    padding: 0.75rem;
    margin: unset;
}

.container-dropdown li{
    line-height: 2.5;
}

.container-dropdown li label{
    margin-bottom: unset;
    margin-left: 0.5rem;
}

.logo-bank{
    height: 1.5rem;
}

</style>